<script setup lang="ts">
import type { SurroundArticle } from '~/types/Article'

defineProps<{
  previousArticle: SurroundArticle | null
  nextArticle: SurroundArticle | null
}>()

const localePath = useLocalePath()
</script>

<template>
  <div>
    <div
      v-if="previousArticle || nextArticle"
      class="grid sm:grid-cols-2 gap-8 mt-8 md:mt-16"
    >
      <!-- Previous Article -->
      <div v-if="previousArticle" class="flex">
        <ULink
          :to="localePath(`/articles/${previousArticle.slug}`)"
          class="flex flex-col flex-grow not-prose ke-card group"
        >
          <div class="relative overflow-hidden">
            <img
              :src="previousArticle.cover"
              :alt="previousArticle.alt || previousArticle.title"
              class="w-full aspect-[1200/630] transition-transform duration-500 hover:scale-110"
            />
          </div>
          <div class="p-6 flex flex-col flex-grow text-left">
            <p
              class="font-medium text-neutral-900 dark:text-white text-base mb-2 hover:text-primary-500 dark:hover:text-primary-400 transition-colors duration-500"
            >
              {{ previousArticle.title }}
            </p>
            <p
              class="text-sm font-normal text-neutral-500 dark:text-neutral-400 line-clamp-2 mb-4 flex-grow"
            >
              {{ previousArticle.description }}
            </p>
            <div class="flex mt-auto justify-start">
              <UIcon
                name="i-tabler-circle-arrow-left"
                class="w-6 h-6 text-neutral-600 dark:text-white group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors duration-500"
              />
            </div>
          </div>
        </ULink>
      </div>
      <div v-else class="hidden sm:block"></div>

      <!-- Next Article -->
      <div v-if="nextArticle" class="flex">
        <ULink
          :to="localePath(`/articles/${nextArticle.slug}`)"
          class="flex flex-col flex-grow not-prose ke-card group"
        >
          <div class="relative overflow-hidden">
            <img
              :src="nextArticle.cover"
              :alt="nextArticle.alt || nextArticle.title"
              class="w-full aspect-[1200/630] transition-transform duration-500 group-hover:scale-110"
            />
          </div>
          <div class="p-6 flex flex-col flex-grow text-right">
            <p
              class="font-medium text-neutral-900 dark:text-white text-base mb-2 hover:text-primary-500 dark:hover:text-primary-400 transition-colors duration-500"
            >
              {{ nextArticle.title }}
            </p>
            <p
              class="text-sm font-normal text-neutral-500 dark:text-neutral-400 line-clamp-2 mb-4 flex-grow"
            >
              {{ nextArticle.description }}
            </p>
            <div class="flex mt-auto justify-end">
              <UIcon
                name="i-tabler-circle-arrow-right"
                class="w-6 h-6 text-neutral-600 dark:text-white group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors duration-500"
              />
            </div>
          </div>
        </ULink>
      </div>
      <div v-else class="hidden sm:block"></div>
    </div>
  </div>
</template>
